<template>
    <div>
        <b-button
            @click="showChatGPTModal"
            :disabled="isLoading"
            style="
                font-size: 0.55rem;
                padding: 0.4rem 0.8rem;
                height: 1.785rem;
                width: 2.7rem;
                line-height: 1.2;
                color: white;
                background-color: #007bff;
                border: 1px solid #007bff;
                box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
                border-radius: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                margin-left: 10px;
                transition: box-shadow 0.3s ease-in-out;
            "
            onmouseover="this.style.boxShadow='0 0 10px yellow, 0 0 20px yellow, 0 0 30px yellow'"
            onmouseout="this.style.boxShadow='0 0 5px rgba(0, 123, 255, 0.5)'"
        >
            <i
                class="fas fa-lightbulb"
                style="
                    font-size: 1rem;
                    margin-right: 0.4rem;
                    color: yellow;
                    transition: box-shadow 0.3s ease-in-out;
                "
            ></i>
            <span>Ask Amy</span>
        </b-button>

        <b-modal
            id="chatgpt-modal"
            ref="chatgptModal"
            title="AI Assistant"
            @ok="handleAmsChatGPTSubmit"
            @hidden="resetChat"
            header-class="p-0"
            footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap"
        >
            <template #modal-title>
                <div
                    class="title-block text-center p-3 d-flex align-items-center justify-content-center"
                    style="
                        background: linear-gradient(
                            90deg,
                            rgba(75, 108, 183, 0.7),
                            rgba(24, 40, 72, 0.7)
                        );
                        border-radius: 10px 10px 0 0;
                        color: white;
                        position: relative;
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
                        backdrop-filter: blur(10px);
                    "
                >
                    <img
                        src="/img/icons/robot.png"
                        alt="Assistant Icon"
                        style="width: 45px; height: 45px; margin-right: 10px"
                    />
                    <span
                        style="
                            font-size: 1.5rem;
                            font-weight: bold;
                            text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
                        "
                    >
                        Amy: Your AMS Assistant
                    </span>
                    <div
                        class="close-btn"
                        @click="cancelChatGPTModal()"
                        style="
                            position: absolute;
                            right: 15px;
                            top: 10px;
                            cursor: pointer;
                        "
                    >
                        <i class="fas fa-times"></i>
                    </div>
                </div>
            </template>
            <form
                class="my-3 py-3"
                @submit.stop.prevent="handleAmsChatGPTSubmit"
            >
                <TextareaWithAudio
                    v-model="chatgptQuestion"
                    class="form-control w-100"
                    :disabled="isLoading"
                    :id="idAttr"
                    :placeholder="'Type a question, or click the microphone to record...'"
                    :rows="rows"
                    :max-rows="maxRows"
                    :resize="true"
                    style="margin-bottom: 10px"
                />
                <div class="example-prompts">
                    <b-row>
                        <b-col
                            v-for="(prompt, index) in examplePrompts"
                            :key="prompt.text"
                            cols="12"
                            md="6"
                            lg="3"
                            class="mb-3 d-flex justify-content-center"
                        >
                            <div
                                @click="setPromptAndInitiateChat(prompt.text)"
                                :style="[
                                    promptBoxStyle,
                                    hoverStyles[prompt.text],
                                ]"
                                @mouseover="addHoverStyle(prompt.text)"
                                @mouseleave="removeHoverStyle(prompt.text)"
                                class="position-relative"
                            >
                                <b-icon
                                    :icon="prompt.icon || 'lightbulb'"
                                    font-scale="1.5"
                                    class="me-2"
                                    :style="iconStyle"
                                ></b-icon>
                                <span :style="textStyle">{{
                                    prompt.text
                                }}</span>

                                <!-- Delete icon - only shown for user-added prompts -->
                                <b-icon
                                    v-if="!isDefaultPrompt(prompt.text)"
                                    icon="trash"
                                    variant="danger"
                                    font-scale="1"
                                    class="position-absolute top-0 end-0 me-1 mt-1"
                                    @click.stop="deletePrompt(index)"
                                    style="
                                        cursor: pointer;
                                        opacity: 0.7;
                                        font-size: 0.8rem;
                                    "
                                ></b-icon>
                            </div>
                        </b-col>

                        <b-col
                            cols="12"
                            md="6"
                            lg="3"
                            class="mb-3 d-flex justify-content-center"
                        >
                            <div
                                @click="showPromptForm = true"
                                :style="[
                                    promptBoxStyle,
                                    {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    },
                                ]"
                                @mouseover="addHoverStyle('plus')"
                                @mouseleave="removeHoverStyle('plus')"
                            >
                                <b-icon
                                    icon="plus-circle"
                                    font-scale="2"
                                    class="me-2"
                                    :style="iconStyle"
                                ></b-icon>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="showPromptForm" class="my-3">
                    <b-form @submit.prevent="addPrompt">
                        <b-form-group label="Prompt Text">
                            <b-form-input
                                v-model="newPrompt.text"
                                placeholder="Enter your prompt text"
                            ></b-form-input>
                        </b-form-group>
                        <b-button type="submit" variant="primary"
                            >Add Prompt</b-button
                        >
                        <b-button
                            @click="showPromptForm = false"
                            variant="secondary"
                            >Cancel</b-button
                        >
                    </b-form>
                </div>

                <b-button
                    size="sm"
                    variant="info"
                    type="submit"
                    :disabled="isLoading || !chatgptQuestion"
                >
                    <span v-if="isLoading">
                        <b-spinner small></b-spinner>
                        Processing...
                    </span>
                    <span v-else> Ask Now </span>
                </b-button>
            </form>
            <div class="chat-container">
                <transition-group name="fade" tag="div" class="chat-messages">
                    <div
                        v-for="(chat, index) in chatResponses"
                        :key="index"
                        style="
                            display: flex;
                            flex-direction: column;
                            margin-bottom: 10px;
                        "
                    >
                        <div
                            style="
                                align-self: flex-end;
                                background-color: lightgrey;
                                padding: 10px;
                                margin: 10px 0;
                                border-radius: 10px 10px 0px 10px;
                                width: fit-content;
                                max-width: 80%;
                            "
                        >
                            <strong>User:</strong> {{ chat.question }}
                        </div>
                        <div
                            style="
                                align-self: flex-start;
                                background-color: #fff;
                                padding: 10px;
                                margin: 10px 0;
                                border-radius: 10px 10px 0 10px;
                                width: fit-content;
                                max-width: 80%;
                                border: 1px solid #ccc;
                            "
                        >
                            <strong>Amy:</strong>
                            <div
                                v-html="formatChatResponse(chat.response)"
                            ></div>
                        </div>
                    </div>
                </transition-group>
            </div>

            <template #modal-footer="{ ok, cancel }">
                <div class="d-flex justify-content-center w-100">
                    <b-button
                        variant="secondary"
                        class="mt-2 me-2"
                        @click="fetchPromptData"
                        :disabled="!isPromptDataReady || isLoading"
                        style="
                            width: 150px;
                            height: 40px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0;
                        "
                    >
                        <b-icon
                            icon="download"
                            font-scale="1.5"
                            class="me-2"
                        ></b-icon>
                        Prompt Data
                    </b-button>

                    <b-button
                        variant="info"
                        class="mt-2"
                        @click="cancel"
                        :disabled="isLoading"
                        style="
                            width: 150px;
                            height: 40px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0;
                        "
                    >
                        Cancel
                    </b-button>
                </div>
                <div style="position: relative">
                    <b-button
                        variant="danger"
                        size="sm"
                        @click="clearChatResponses"
                        :disabled="isLoading"
                        style="
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            background: transparent;
                            border: none;
                            color: red;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            bottom: 0px;
                            left: 400px;
                        "
                    >
                        <i class="fas fa-trash"></i>
                    </b-button>
                    <b-button
                        variant="info"
                        size="sm"
                        @click="exportChat"
                        :disabled="isLoading"
                        style="
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            background: transparent;
                            border: none;
                            color: blue;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            bottom: 0px;
                            left: 370px;
                        "
                    >
                        <i class="fas fa-file-export"></i>
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>

    <!-- AI Assistant Modal -->
</template>

<script>
import TextareaWithAudio from '@/components/TextareaWithAudio.vue'
import moment from 'moment'
import _ from 'lodash'
export default {
    name: 'AskAmy',
    components: {
        TextareaWithAudio,
    },
    props: [
        'pagination',
        'tableLoading',
        'query',
        'filters',
        'queryOptionsValue',
    ],

    data() {
        return {
            // loading: false,
            promptData: [],
            rows: 3,
            maxRows: 5,
            isLoading: false,
            chatgptQuestion: '',
            chatgptResponse: '', // Added
            chatResponses: [],
            isPromptDataReady: false,
            currentChartType: 'Bar',
            chartData: null,

            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
            },
            newPrompt: {
                text: '',
                icon: '',
            },
            idAttr: '',
            selectedPrompts: [],
            examplePrompts: [
                {
                    text: 'Overview of pending tasks and due dates.',
                    icon: 'calendar',
                },
                {
                    text: 'Completed activities summary for the week.',
                    icon: 'check-circle',
                },
                {
                    text: 'Activity history for our corporation last month.',
                    icon: 'file-earmark',
                },
                {
                    text: 'List of overdue tasks with assigned officers.',
                    icon: 'exclamation-triangle',
                },
            ],
            hoverStyles: {},
            promptBoxStyle: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                padding: '10px',
                border: '1px solid rgba(0, 123, 255, 0.5)',
                color: '#007bff',
                backgroundColor: 'rgba(0, 123, 255, 0.1)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                borderRadius: '5px',
                textAlign: 'center',
            },
            iconStyle: {
                marginRight: '10px',
            },
            textStyle: {
                fontSize: '0.9rem',
            },
            prompts: [],
            showPromptForm: false,
            chatgptpromptData: [
                {
                    ACTIVITY: 367,
                    ACTIVITY_TYPE: 'AMS Web',
                    CUSTOMER: 'Activity Management Solution AMS',
                    SCHEDULED_FOR: '2024-06-27 7:46:00',
                    ACTIVITY_DESCRIPTION:
                        'Observed there are static id while adding a date and title in holiday section, in company setting page. Require a proper class or id defined for it since in that particular page we have more than 12 values with same id or same class',
                    CUSTOMER_ADDRESS: 'kingston 10',
                },
            ],
        }
    },
    computed: {
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
    },

    created() {
        this.loadPrompts() // Load stored prompts on component creation
    },
    methods: {
        isDefaultPrompt(text) {
            const defaultPrompts = [
                'Overview of pending tasks and due dates.',
                'Completed activities summary for the week.',
                'Activity history for our corporation last month.',
                'List of overdue tasks with assigned officers.',
            ]
            return defaultPrompts.includes(text)
        },
        deletePrompt(index) {
            // Remove the prompt from the examplePrompts array
            this.examplePrompts.splice(index, 1)

            // Update localStorage to remove user-added prompts
            const userPrompts = this.examplePrompts.filter(
                prompt => !this.isDefaultPrompt(prompt.text)
            )
            localStorage.setItem('userPrompts', JSON.stringify(userPrompts))
        },
        loadPrompts() {
            const storedPrompts =
                JSON.parse(localStorage.getItem('userPrompts')) || []
            this.examplePrompts = [...this.examplePrompts, ...storedPrompts]
        },
        setPromptAndInitiateChat(text) {
            this.chatgptQuestion = text
            this.handleAmsChatGPTSubmit() // Call the method to initiate the chat
        },
        handlePageChange() {
            this.doSearch(false, true) // Call doSearch with isPagination set to true
        },
        addPrompt() {
            if (this.newPrompt.text) {
                const newPrompt = {
                    text: this.newPrompt.text,
                    icon: this.newPrompt.icon,
                }
                this.examplePrompts.push(newPrompt) // Add to the list of prompts
                this.prompts.push(newPrompt) // Store in the custom prompts list
                localStorage.setItem(
                    'userPrompts',
                    JSON.stringify(this.prompts)
                )
                this.newPrompt.text = ''
                this.newPrompt.icon = ''
                this.showPromptForm = false // Hide the form after adding the prompt
            }
        },
        loadPrompts() {
            const storedPrompts = localStorage.getItem('userPrompts')
            if (storedPrompts) {
                this.prompts = JSON.parse(storedPrompts)
                this.examplePrompts = [...this.examplePrompts, ...this.prompts]
            }
        },

        addHoverStyle(text) {
            this.$set(this.hoverStyles, text, {
                backgroundColor: '#f0f0f0',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            })
        },
        removeHoverStyle(text) {
            this.$set(this.hoverStyles, text, {})
        },
        formatApiResponse(response) {
            if (typeof response !== 'object' || response === null) {
                return `<p>${response}</p>`
            }

            let formattedResponse = '<div>'

            for (const [key, value] of Object.entries(response)) {
                if (Array.isArray(value)) {
                    formattedResponse += `<strong>${key}:</strong><ul>`
                    value.forEach(item => {
                        formattedResponse += `<li>${this.formatApiResponse(
                            item
                        )}</li>`
                    })
                    formattedResponse += '</ul>'
                } else if (typeof value === 'object') {
                    formattedResponse += `<strong>${key}:</strong>${this.formatApiResponse(
                        value
                    )}`
                } else {
                    formattedResponse += `<strong>${key}:</strong> ${value}<br>`
                }
            }

            formattedResponse += '</div>'

            return formattedResponse
        },
        analyzeData() {
            const totalActivities = this.promptData.length
            const completedActivities = this.promptData.filter(
                order => order.COMPLETED === 'Yes'
            ).length
            const pendingActivities = totalActivities - completedActivities

            const customerActivitiesMap = this.promptData.reduce(
                (acc, order) => {
                    const customer = order.CUSTOMER
                    if (!acc[customer]) {
                        acc[customer] = { total: 0, completed: 0, pending: 0 }
                    }
                    acc[customer].total += 1
                    if (order.COMPLETED === 'Yes') {
                        acc[customer].completed += 1
                    } else {
                        acc[customer].pending += 1
                    }
                    return acc
                },
                {}
            )

            return {
                totalActivities,
                completedActivities,
                pendingActivities,
                customerActivities: Object.entries(customerActivitiesMap).map(
                    ([name, data]) => ({
                        name,
                        total: data.total,
                        completed: data.completed,
                        pending: data.pending,
                    })
                ),
            }
        },
        // countActivities() {
        //     return this.promptData.length
        // },

        formatChatResponse(response) {
            if (!response) return ''

            // Convert plain text to HTML, adding styling and formatting
            return response
                .split('\n')
                .map(line => line.trim())
                .filter(line => line.length > 0)
                .map(line => {
                    // Add custom formatting rules here
                    if (line.includes('important')) {
                        line = `<span class="highlight">${line}</span>`
                    }
                    return `<div class="message-body">${line}</div>`
                })
                .join('')
        },

        resetChat() {
            // Define what should happen when the chat is reset
            this.chatgptQuestion = ''
            this.chatgptResponse = ''
            this.chatResponses = []
        },
        clearChatResponses() {
            this.chatResponses = []
        },
        showConfirmationModal() {
            this.$refs.confirmationModal.show()
        },
        handleConfirmation() {
            this.fetchActivities()
            this.$refs.confirmationModal.hide()
            this.$refs.chatgptModal.show()
        },
        cancelConfirmation() {
            this.$refs.confirmationModal.hide()
        },
        showChatGPTModal() {
            this.promptData = [] // Clear previous data
            this.chatgptQuestion = ''
            this.chatgptResponse = ''
            this.chatResponses = [] // Clear previous chat history
            this.isLoading = false // Ensure loading state is reset

            // Always fetch fresh data when modal is opened
            this.isPromptDataReady = false // Reset the flag to allow new data to load
            this.fetchActivities() // Fetch the data every time the modal is opened

            this.$refs.chatgptModal.show() // Open modal
        },

        resetChat() {
            // Define what should happen when the chat is reset
            this.chatgptQuestion = ''
            this.chatgptResponse = ''
        },
        openFilter() {
            // Define what should happen when the filter is opened
            this.shouldShowFilters = !this.shouldShowFilters
        },
        formatChatResponse(response) {
            if (!response) return ''

            // Convert plain text to HTML, adding styling and formatting
            return response
                .split('\n')
                .map(line => line.trim())
                .filter(line => line.length > 0)
                .map(line => {
                    // Add custom formatting rules here
                    if (line.includes('important')) {
                        line = `<span class="highlight">${line}</span>`
                    }
                    return `<div class="message-body">${line}</div>`
                })
                .join('')
        },
        async fetchAllPagesData() {
            try {
                // Emit the loading event to show the loading spinner
                this.$emit('updateTableLoading', true)
                console.log('Fetching data from all pages in parallel...')

                // Log the current pagination settings
                console.log('Pagination Page Size:', this.pagination.pageSize)
                console.log('Pagination Total:', this.pagination.total)

                // Calculate the total number of pages
                const totalPages = Math.ceil(
                    this.pagination.total / this.pagination.pageSize
                )
                console.log('Total Pages:', totalPages)

                let currentPage = 1
                let allData = []

                // Fetch data across all pages
                while (currentPage <= totalPages) {
                    const pagePromises = []

                    // Fetch up to pageSize pages in parallel
                    for (
                        let i = 0;
                        i < this.pagination.pageSize &&
                        currentPage <= totalPages;
                        i++
                    ) {
                        console.log(`Fetching data from page ${currentPage}...`)
                        pagePromises.push(this.fetchPageData(currentPage))
                        currentPage++
                    }

                    // Await all the page data to be fetched
                    const batchData = await Promise.all(pagePromises)

                    // Flatten the batch data and add it to the allData array
                    allData = allData.concat(batchData.flat())

                    console.log(
                        `Data fetched for pages in batch: ${batchData.length} pages`
                    )

                    // Check if the total items collected have reached or exceeded the pagination total
                    if (allData.length >= this.pagination.total) {
                        // If we have more data than needed, slice it down to the required total
                        allData = allData.slice(0, this.pagination.total)
                        break // Stop fetching more data
                    }
                }

                console.log('All Pages Data:', allData)
                return allData // Return the combined data
            } catch (error) {
                console.error('Error fetching all pages data:', error)
            } finally {
                // Emit the loading event to hide the loading spinner
                this.$emit('updateTableLoading', false)
            }
        },
        async fetchPageData(page) {
            try {
                // Clone the existing orders from Vuex state instead of dispatching a new action
                const orders = JSON.parse(
                    JSON.stringify(this.$store.state.orders.items)
                )

                // Process the cloned orders for local use
                const localOrders = orders.map(order => ({
                    id: order.id,
                    reference_no: order.reference_no || 'No Reference',
                    schedule_at: order.schedule_at || 'No Date Provided',
                    completed: order.completed,
                    customer: order.customer,
                    progress_status: order.progress_status,
                    description: order.description,
                    type: order.type,
                    driver: order.driver,
                    grand_total: order.grand_total,
                    completedTasks: order.completedTasks,
                    totalTasks: order.totalTasks,
                }))

                return localOrders
            } catch (error) {
                console.error(`Error fetching data for page ${page}:`, error)
                return [] // Return empty array on error
            }
        },
        async fetchActivities() {
            try {
                this.isLoading = true

                // Clear any previous data before fetching new data
                this.promptData = []

                // Fetch the new data
                const allData = await this.fetchAllPagesData()

                if (allData.length === 0) {
                    console.log('No orders available to process.')
                    this.showToast(
                        'info',
                        'No data available',
                        'No orders were found to process.'
                    )
                    return
                }

                // Format the orders data for display in Ask Amy
                const formattedOrders = allData.map(order => ({
                    ACTIVITY: order.id,
                    REFERENCE_NO: order.reference_no || 'No Reference',
                    DUE: order.schedule_at || 'No Date Provided',
                    COMPLETED: order.completed ? 'Yes' : 'No',
                    CUSTOMER: order.customer?.name || 'Customer Not Available',
                    STATUS: order.progress_status?.name || 'No Status',
                    DESCRIPTION: order.description || 'No description provided',
                    TYPE: order.type?.name || 'No Type',
                    OFFICER:
                        `${order.driver?.first_name || ''} ${
                            order.driver?.last_name || ''
                        }`.trim() || 'No Officer Assigned',
                    TOTAL: order.grand_total || 0,
                    TASKS: `${order.completedTasks || 0} / ${
                        order.totalTasks || 0
                    }`,
                }))

                this.promptData = formattedOrders // Update data
                this.isPromptDataReady = true
                this.showToast(
                    'custom-toast',
                    'Data processed',
                    'Orders data processed successfully.'
                )
            } catch (error) {
                console.error('Error processing activities:', error)
                this.showToast(
                    'custom-toast-error',
                    'Data Processing Failed',
                    'Failed to process activities.'
                )
            } finally {
                this.isLoading = false // Reset loading state
            }
        },
        showToast(variant, title, message) {
            this.$bvToast.toast(message, {
                variant: variant,
                solid: true,
            })
        },

        async handleAmsChatGPTSubmit() {
            if (!this.isPromptDataReady) {
                console.error('Prompt data is not ready.')
                // this.$toast.error(
                //     'No data available to send. Please fetch the data first.'
                // )
                this.showToast(
                    'error',
                    'prompt data not available',
                    'No data available to send. Please fetch the data first.'
                )

                return
            }

            if (this.isLoading) {
                // Prevent multiple submissions while a request is in progress
                return
            }

            this.isLoading = true // Start loading state to prevent further submissions

            try {
                // Analyze the data
                const {
                    totalActivities,
                    completedActivities,
                    pendingActivities,
                    customerActivities,
                } = this.analyzeData()

                // Prepare the data to be sent
                const promptData = this.promptData.map(order => ({
                    'Activity ID': order.ACTIVITY,
                    'Reference No': order.REFERENCE_NO,
                    'Due Date': order.DUE,
                    Completed: order.COMPLETED,
                    Customer: order.CUSTOMER,
                    Status: order.STATUS,
                    Description: order.DESCRIPTION,
                    Type: order.TYPE,
                    Officer: order.OFFICER,
                    Total: order.TOTAL,
                    Tasks: order.TASKS,
                }))

                const selectedQuestion = this.chatgptQuestion

                // Chunk the data into smaller parts directly in this function
                const chunkSize = 50 // Adjust chunk size as needed
                let combinedResponse = ''
                for (let i = 0; i < promptData.length; i += chunkSize) {
                    const chunk = promptData.slice(i, i + chunkSize)
                    const postData = {
                        question: `
                      Please use the following data to answer the question. Here is the data:
                      ${JSON.stringify(chunk, null, 2)}

                      Question: ${selectedQuestion}
                      Total activities: ${totalActivities}
                      Completed activities: ${completedActivities}
                      Pending activities: ${pendingActivities}
                      Customer activities:
                      ${customerActivities
                          .map(
                              customer => `
                          - ${customer.name}: Total - ${
                                  customer?.total ?? 0
                              }, Completed - ${customer.completed}, Pending - ${
                                  customer.pending
                              }
                      `
                          )
                          .join('\n')}
                  `,
                        additionalData: chunk,
                    }

                    console.log(
                        'Sending the following chunked data to the API:',
                        JSON.stringify(postData, null, 2)
                    )

                    // Make the API request
                    const response = await fetch(
                        'https://y5d4ma9d6b.execute-api.us-east-1.amazonaws.com/default/ChatGPTProxy',
                        {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(postData, null, 2),
                        }
                    )

                    if (!response.ok) {
                        throw new Error(
                            `HTTP error! Status: ${response.status}`
                        )
                    }

                    // Process the response
                    const result = await response.json()

                    if (result && result.answer) {
                        // Take only the first valid response
                        combinedResponse = this.formatApiResponse(result.answer)
                        break // Stop processing further chunks once a valid response is received
                    } else {
                        throw new Error('Unexpected response format')
                    }
                }

                // Once all chunks are processed, update the UI with the combined response
                this.chatgptResponse = combinedResponse

                // Save the question and combined response to chatResponses
                this.chatResponses.push({
                    question: this.chatgptQuestion,
                    response: this.chatgptResponse,
                })

                // Clear the input field and reset
                this.chatgptQuestion = ''
            } catch (error) {
                console.error('Error querying ChatGPT API:', error)
            } finally {
                this.isLoading = false // Reset loading state to allow new submissions
            }
        },
        cancelChatGPTModal() {
            this.$refs.chatgptModal.hide()
        },
        exportChat() {
            const chatData = this.chatResponses.map(chat => ({
                User: chat.question,
                Amy: chat.response,
            }))
            const csv = this.jsonToCsv(chatData)
            const dataUri =
                'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)

            const exportFileDefaultName = 'chatData.csv'

            const linkElement = document.createElement('a')
            linkElement.setAttribute('href', dataUri)
            linkElement.setAttribute('download', exportFileDefaultName)
            linkElement.click()
        },

        async fetchPromptData() {
            const csv = this.jsonToCsv(this.promptData)
            const dataUri =
                'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)

            const exportFileDefaultName = 'promptData.csv'

            const linkElement = document.createElement('a')
            linkElement.setAttribute('href', dataUri)
            linkElement.setAttribute('download', exportFileDefaultName)
            linkElement.click()
        },

        jsonToCsv(json) {
            const items = json
            const header = Object.keys(items[0])
            const csv = [
                header.join(','), // header row first
                ...items.map(row =>
                    header
                        .map(fieldName => JSON.stringify(row[fieldName]))
                        .join(',')
                ),
            ].join('\r\n')

            return csv
        },
    },
}
</script>

<style>
@media (max-width: 1199px) {
    b-button[style] {
        margin-left: 8px !important;
    }
}
@media (max-width: 767px) {
    b-button[style] {
        margin-left: 5px !important;
    }
}

/* testing something */

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.chat-container {
    height: 200px; /* Adjusted height */
    overflow-y: auto;
    margin-bottom: 20px; /* Space for the buttons */
}

.chat-messages {
    display: flex;
    flex-direction: column;
}

.chat-message {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

.user-message {
    align-self: flex-end;
    background-color: lightgrey;
    padding: 10px;
    margin: 10px 0;
    border-radius: 10px 10px 0px 10px;
    width: fit-content;
    max-width: 80%;
}

.amy-message {
    align-self: flex-start;
    background-color: #fff;
    padding: 10px;
    margin: 10px 0;
    border-radius: 10px 10px 0 10px;
    width: fit-content;
    max-width: 80%;
    border: 1px solid #ccc;
}

.clear-chat-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: transparent;
    border: none;
    color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 10px;
    right: 10px;
}
.message-header {
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
    color: #555;
}

.message-body {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
}

.user-message {
    align-self: flex-end;
    background-color: #f1f1f1;
    border: 1px solid #d1d1d1;
    padding: 10px;
    margin: 10px 0;
    border-radius: 10px 10px 0px 10px;
    width: fit-content;
    max-width: 80%;
}

.amy-message {
    align-self: flex-start;
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
    padding: 10px;
    margin: 10px 0;
    border-radius: 10px 10px 0 10px;
    width: fit-content;
    max-width: 80%;
}

.highlight {
    background-color: #ffeb3b;
    font-weight: bold;
}

.b-toast {
    font-family: 'Arial', sans-serif;
    font-size: 0.9rem;
    padding: 1rem;
    border-radius: 0.25rem;
}

/* Custom Toast Styles */
.custom-toast {
    max-width: 250px; /* Control the width of the toast */
    background-color: rgba(0, 0, 0, 0.7); /* Transparent black background */
    color: white; /* White text color */
    padding: 10px; /* Adjust padding */
    border-radius: 8px; /* Rounded corners */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
    font-size: 14px; /* Smaller font size */
}

.custom-toast .toast-header {
    background-color: transparent; /* Make header transparent */
    border-bottom: none; /* Remove border */
    color: white; /* White text color */
}

.custom-toast .toast-body {
    color: #ffd700; /* Highlight the message in gold */
    font-weight: bold; /* Make the message pop */
    font-size: 16px; /* Slightly larger font for the message */
}
</style>
